<template>
	<div class="footer">
		<div class="footer-content">
			<!-- Top Section -->
			<div class="footer-top">
				<!-- Left Side -->
				<div class="footer-left">
					<div class="brand-info">
						<div class="logo-box">
							<img src="../assets/logo.png" alt="">
						</div>
						<div class="brand-text">
							<h3 class="platform-name">隆布传媒</h3>
							<p class="slogan">海量视频学习平台</p>
						</div>
					</div>

					<div class="contact-info">
						<p v-if="settings.phone">咨询电话：{{ settings.phone }}</p>
						<p v-if="settings.email">企业邮箱：{{ settings.email }}</p>
						<p v-if="settings.address">公司地址：{{ settings.address }}</p>
					</div>
				</div>

				<!-- Right Side -->
				<div class="footer-right">
					<div class="footer-nav">
						<router-link to="/">首页</router-link>
						<span class="divider">|</span>
						<router-link to="/course">课程中心</router-link>
						<span class="divider">|</span>
						<router-link to="/personal">个人中心</router-link>
						<span class="divider">|</span>
						<router-link to="/personal?tab=courses">我的课程</router-link>
						<span class="divider">|</span>
						<router-link to="/member">会员中心</router-link>
					</div>

					<div class="qr-section">
						<div class="qr-text">
							<p>扫描二维码</p>
							<p>打开隆布传媒公众号</p>
						</div>
						<div class="qr-code">
							<!-- QR Code Placeholder -->
							<img :src="settings.wechat" alt="QR" v-if="settings.wechat"
								style="width: 100%; height: 100%; display: block;" />
							<div v-else style="background: white; width: 100%; height: 100%; display: block;"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Bottom Section -->
		<div class="footer-bottom">
			<p><a :href="settings.archivalLink">{{ settings.archival }}</a></p>
		</div>
	</div>
</template>

<script>
	import {
		getSetting
	} from '@/api/public'

	export default {
		name: 'PageFooter',
		data() {
			return {
				settings: {
					
				}
			}
		},
		mounted() {
			this.getSiteSettings()
		},
		methods: {
			async getSiteSettings() {
				try {
					const res = await getSetting({
						groupKey: 'kf'
					})
          const rese = await getSetting({
						groupKey: 'init'
					})
					// 根据实际返回结构赋值，这里假设 res.data 是配置对象
					// 如果 res 本身就是数据对象（因为拦截器处理过），则直接使用 res
						this.settings = {
							...this.settings,
							...rese,
              ...res
						}
						console.log('Site settings loaded:', this.settings)
				} catch (error) {
					console.error('Failed to load site settings:', error)
				}
			}
		}
	}
</script>

<style scoped>
	.footer {
		background-color: #1a1a1a;
		/* Dark background matching the image */
		color: #999;
		font-size: 14px;
		width: 100%;
	}

	.footer-content {
		max-width: 1200px;
		margin: 0 auto;
		padding: 50px 20px;
	}

	.footer-top {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		border-bottom: 1px solid #333;
		padding-bottom: 30px;
	}

	/* Left Side */
	.footer-left {
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	.brand-info {
		display: flex;
		align-items: center;
		gap: 15px;
		margin-bottom: 10px;
	}

	.logo-box img {
		width: 50px;
		height: 50px;

	}

	.platform-name {
		color: #ff9900;
		/* Orange color from image */
		font-size: 18px;
		margin: 0 0 5px 0;
	}

	.slogan {
		font-size: 12px;
		margin: 0;
		color: #666;
	}

	.contact-info p {
		margin: 8px 0;
		color: #888;
	}

	/* Right Side */
	.footer-right {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: 30px;
	}

	.footer-nav {
		display: flex;
		gap: 10px;
		align-items: center;
	}

	.footer-nav a {
		text-decoration: none;
		color: #999;
		transition: color 0.3s;
	}

	.footer-nav a:hover {
		color: #fff;
	}

	.divider {
		color: #444;
	}

	.qr-section {
		display: flex;
		align-items: center;
		gap: 15px;
	}

	.qr-text {
		text-align: right;
		font-size: 12px;
		color: #888;
	}

	.qr-text p {
		margin: 2px 0;
	}

	.qr-code {
		width: 80px;
		height: 80px;
		background-color: #fff;
		padding: 5px;
	}

	/* Bottom Section */
	.footer-bottom {
		background-color: #111;
		text-align: center;
		padding: 20px 0;
		border-top: 1px solid #222;
	}

	.footer-bottom p {
		margin: 0;
		font-size: 12px;
		color: #666;
	}

	.footer-bottom a {
		color: #666;
		text-decoration: none;
		margin-left: 10px;
	}

	.footer-bottom a:hover {
		color: #888;
	}
</style>